import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Mail, Eye, EyeOff } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import toast from 'react-hot-toast';
import './login.css';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [carregando, setCarregando] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !senha) { toast.error('Preencha todos os campos'); return; }
    setCarregando(true);
    try {
      await login(email, senha);
      toast.success('Bem-vindo ao painel!');
      navigate('/admin');
    } catch (err: any) {
      toast.error(err?.response?.data?.erro || err?.response?.data?.mensagem || 'Email ou senha incorretos');
    } finally {
      setCarregando(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-bg" />
      <div className="login-card">
        <div className="login-logo">
          <div className="login-diamante"><span>★</span></div>
          <div>
            <span className="login-nome">licmab</span>
            <span className="login-sub">Área Administrativa</span>
          </div>
        </div>

        <h1 className="login-titulo">Entrar no Painel</h1>
        <p className="login-desc">Acesso restrito a administradores da LICMAB.</p>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="campo-grupo">
            <label className="campo-label">E-mail</label>
            <div className="campo-wrapper">
              <span className="campo-icone"><Mail size={16} /></span>
              <input
                type="email"
                className="campo-input com-icone"
                placeholder="admin@licmab.org.br"
                value={email}
                onChange={e => setEmail(e.target.value)}
                autoComplete="email"
                required
              />
            </div>
          </div>

          <div className="campo-grupo">
            <label className="campo-label">Senha</label>
            <div className="campo-wrapper">
              <span className="campo-icone"><Lock size={16} /></span>
              <input
                type={mostrarSenha ? 'text' : 'password'}
                className="campo-input com-icone"
                style={{ paddingRight: '2.8rem' }}
                placeholder="••••••••"
                value={senha}
                onChange={e => setSenha(e.target.value)}
                autoComplete="current-password"
                required
              />
              <button
                type="button"
                className="campo-olho"
                onClick={() => setMostrarSenha(!mostrarSenha)}
                tabIndex={-1}
              >
                {mostrarSenha ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
          </div>

          <button
            type="submit"
            className="btn btn-dourado btn-lg login-submit"
            disabled={carregando}
          >
            {carregando ? 'Entrando...' : 'Entrar'}
          </button>
        </form>

        <div className="login-voltar">
          <a href="/">← Voltar ao site</a>
        </div>
      </div>
    </div>
  );
}
